module.exports = __webpack_public_path__ + "img/orange_053.d30134d1.png";